import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/18k";

export const Route = createFileRoute("/pakistan/18k")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `18K Gold Rate in Pakistan Today — Live Per Tola & Per Gram | 18 Carat Sona Ka Bhao`;
    const description = `Live 18K (75% pure) gold rate in Pakistan — used for stone-set and diamond-mount jewellery. 18 carat sona ka bhao per tola, per 10 gram, per gram across every major city. Refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "karat", karat: "18k" }}
      h1="18K Gold Price in Pakistan Today — Live Rate"
      intro="Live 18K (75% pure) gold rate — used for stone-set jewellery, diamond mounts and modern designs. Per tola, per 10 gram, per gram across all major Pakistani sarafa bazaars, refreshed every 10 minutes."
    />
  ),
});